import _ from 'lodash';
import React from 'react';

import FormField from 'components/FormField';
import Label from 'components/Label';
import {
  default as BookingSelectField,
  buildBookingOptionFromBookingSet
} from 'components/Fields/BookingSelectField';

import {headOption} from 'utils/common';

export const initialValues = ({initialBookingSet}) => {
  const bookings = _.get(initialBookingSet, 'bookings', []).filter(
    booking => !booking.cancelled
  );

  if (bookings.length === 1) {
    return {
      booking: headOption(bookings, buildBookingOptionFromBookingSet)
    };
  }

  return {};
};

const BookingSection = ({fetchBookingOptions, clearBookingOption}) => (
  <FormField className="BookingSection">
    <Label>Current Booking</Label>
    <BookingSelectField
      fetchBookingOptions={fetchBookingOptions}
      clearBookingOption={clearBookingOption}
      showDropdownWhenEmpty={true}
      placeholder="Select booking ..."
    />
  </FormField>
);

export default BookingSection;
